import React from 'react'

export const RequiredMessage = () => {
  return <span className="contact-form__required">This field is required.</span>
}
